import React, { useMemo } from "react";
import { ThemedIcon } from "@me8eon/icons";
import { useTranslation } from "@me8eon/translation";
import useSearchStore from "me-at-eon/src/store/searchStore";
import { TileDataInterface } from "@me8eon/fav_storage";
import { AppsData } from "./apps.data";
import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import { useJwtToken } from "@me8eon/react_authentication";

interface AddRemoveDashboardButtonProps {
    appData: TileDataInterface | AppsData;
}

const buttonStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#f9f6f4",
    padding: "3px 8px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer"
};

const AddRemoveDashboardButton: React.FC<AddRemoveDashboardButtonProps> = ({ appData }) => {
    const t = useTranslation();
    const jwt = useJwtToken()
    const { favData, toggleFavourite, setPrefData } = useSearchStore();
    const [showAdded, setShowAdded] = React.useState(false);

    const isAppInDashboard = useMemo(() => {
        return favData.favApps.some((app: TileDataInterface) => app.title === appData?.title && app.status);
    }, [favData.favApps, appData?.title]);

    const handleAddFavorite = (app: TileDataInterface) => {
        const { full_text_embeddings, ...cleanAppData } = app;
        toggleFavourite(cleanAppData);
        setPrefData(jwt);
        setShowAdded(true);
        setTimeout(() => {
            setShowAdded(false);
        }, 2000);
    };

    // if (isAppInDashboard) return null;

    return (
        <>
            <style>
                {`
                    @media (max-width: 540px) {
                        .add-app-label {
                            display: none;
                        }
                    }
                `}
            </style>
            {!isAppInDashboard && (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button
                        onClick={() => handleAddFavorite(appData as TileDataInterface)}
                        className="add-icon"
                        style={buttonStyle}
                        title={t("searchPage.addAppTooltip")}
                    >
                        <ThemedIcon
                            name="add"
                            scheme="red500"
                            title={t("searchPage.addAppTooltip")}
                        />
                        <span className="add-app-label">{t("searchPage.addAppTooltip")}</span>
                    </button>
                </div>
            )}
            {showAdded &&
                <button
                    // onClick={() => handleAddFavorite(appData as TileDataInterface)}
                    className="add-icon"
                    style={buttonStyle}
                    title={t("searchPage.addAppTooltip")}
                >
                    <EonUiIcon name="radio_checkbox_tick" style={{ color: "green" }} />
                    <span className="add-app-label">{t("searchPage.addedAppTooltip")}</span>
                </button>}
        </>
    );
};

export default AddRemoveDashboardButton;